import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IEntityApiService } from 'app/projects/entity/src/lib/interfaces/entity.service.interface';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IExperienceWidgetQuery } from '../interfaces/experience-widget.query.interface';
import { ExperienceWidgetCommand } from '../models/experience-widget.command.model';
import { ExperienceWidget } from '../models/experience-widget.model';

@Injectable()
export class ExperienceWidgetApiService extends EntityService<IExperienceWidgetQuery, ExperienceWidgetCommand> implements IEntityApiService<ExperienceWidget> {
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) environment: IEnvironment) {
        super(http, environment.apiUrl, 'engage/experiences-widgets');
    }

    getAll(): Observable<ExperienceWidget[]> {
        return this._getAll().pipe(map((queries) => queries.map((query) => new ExperienceWidget(query))));
    }

    create(entity: ExperienceWidget): Observable<ExperienceWidget> {
        const data = new ExperienceWidgetCommand(entity);

        return this._create(data).pipe(map((query) => new ExperienceWidget(query)));
    }

    read(id: string): Observable<ExperienceWidget> {
        return this._read(id).pipe(map((query) => new ExperienceWidget(query)));
    }

    update(entity: ExperienceWidget): Observable<ExperienceWidget> {
        const data = new ExperienceWidgetCommand(entity);
        return this.http.patch<IExperienceWidgetQuery>(`${this.apiUrl}/${this.entities}/${entity.id}`, data).pipe(map((query) => new ExperienceWidget(query)));
    }

    getWidgetsByExperienceId(experienceId: string): Observable<ExperienceWidget[]> {
        return this.http
            .get<IExperienceWidgetQuery[]>(`${this.apiUrl}/engage/experiences/${experienceId}/widgets`)
            .pipe(map((queries) => queries.map((query) => new ExperienceWidget(query))));
    }

    delete(id: string): Observable<any> {
        return this._delete(id);
    }
}
